if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        /* perf 30.09 A-06: dotknięcie w trakcie pobierania nowego wariantu nie ginie - czeka do końca aktualizacji
           i wysyła się z id nowego wariantu (endVariantPending). Od razu ten sam stan ładowania co przy zwykłym dodaniu. */
        if (this.variantPending || this.submitQueued) {
          this.submitQueued = true;
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");
          return;
        }

        this.submitForm();
      }

      submitForm() {
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.skipCart = false;
        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput?.dataset?.skipCart === 'true') {
          this.skipCart = true;
        }

        /* perf 30.09 B-11: GET /cart.js tylko gdy wlaczony domyslny upsell (data-upsell-variant-id).
           Bez niego zapytanie niczego nie zmienialo, a dokladalo jeden obieg sieci przed kazdym dodaniem do koszyka. */
        const addToCart = () => fetch(`${routes.cart_add_url}`, config);
        const addRequest = this.upsellVariantId
          ? fetch(`${routes.cart_url}.js`)
              .then((response) => response.json())
              .then((cartState) => {
                if (cartState.item_count === 0) {
                  return fetch(
                    `${routes.cart_add_url}`,
                    this.getUpsellProductConfig()
                  );
                }
              })
              .then(addToCart)
          : addToCart();

        addRequest
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (this.skipCart) {
              console.log('Redirecting to checkout');
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            // perf 30.09 BUG-2: stan „pusta” szuflady zdejmujemy tylko po udanym dodaniu (dawniej w finally, także po błędzie
            // 422/sieci - pusta szuflada traciła wtedy wygląd pustej: „Koszyk • 0”, 0,00 zł, ucięta lista)
            if (this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              /* K2 (10.10, c-zestaw): karta „Dopełnij zestaw” na stronie /cart - klientka zostaje na stronie, listę i podsumowanie
                 odświeża CartItems po cartUpdate. Zamknięta szuflada dostaje nową treść przy otwarciu (cart-drawer.js open, jak po
                 zmianie ilości - lab A/B 10.10), otwarta po cichu (svSkipOpen); na dole ekranu „Dodano do koszyka: X” (uwaga CEO 23:05). */
              const svOnCart = this.closest("#MainContent") && document.querySelector("cart-items") && this.cart.tagName === "CART-DRAWER";
              if (svOnCart && !this.cart.classList.contains("active")) {
                const cart = this.cart;
                const mark = cart.querySelector("cart-drawer-items") || cart.querySelector(".drawer__inner");
                cart.svPending = () => {
                  if (mark && !mark.isConnected) return;
                  cart.svSkipOpen = Date.now();
                  cart.renderContents(response);
                };
              } else {
                if (svOnCart) this.cart.svSkipOpen = Date.now();
                this.cart.renderContents(response);
              }
              if (svOnCart && typeof window.svCartNote === "function" && response && response.product_title)
                window.svCartNote(
                  response.product_title +
                    (response.variant_title && response.variant_title !== "Default Title" ? " (" + response.variant_title + ")" : "")
                );
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.variantPending) this.variantStateSet = true; // perf 30.09 A-06
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      /* perf 30.09 A-06: na czas pobierania nowego wariantu przycisk NIE dostaje atrybutu disabled (dotknięcie w tym
         oknie ginęło bez śladu: lab E S3, 0,17–0,71 s, 1 z 3 szybkich sekwencji). Ten sam wygląd daje klasa .disabled
         (base.css: .button.disabled = .button:disabled, przezroczystość 0,5). Wołane z product-info.js. */
      setVariantPending() {
        this.variantPending = true;
        this.variantStateSet = false;
        this.submitButton.classList.add("disabled");
      }

      /* ok = false: odpowiedź z nowym wariantem nie doszła (błąd sieci) - jak dotąd przycisk zostaje wyłączony,
         chyba że stan przycisku zdążył już ustawić toggleSubmitButton. */
      endVariantPending(ok = true) {
        if (!this.variantPending) return;
        this.variantPending = false;
        if (!ok && !this.variantStateSet) this.submitButton.setAttribute("disabled", "disabled");
        this.variantStateSet = false;
        if (!this.submitQueued) {
          this.submitButton.classList.remove("disabled");
          return;
        }
        if (this.submitButton.hasAttribute("disabled")) {
          // nowy wariant wyprzedany / niedostępny: kliknięcie przepada, przycisk pokazuje stan wariantu
          this.submitQueued = false;
          this.submitButton.classList.remove("disabled", "loading");
          this.querySelector(".loading__spinner").classList.add("hidden");
          return;
        }
        // wysyłka w osobnym zadaniu, po długim zadaniu aktualizacji wariantu (wzorzec Shopify "yield to main thread");
        // do tej chwili kolejne dotknięcia trafiają do tej samej kolejki (onSubmitHandler), więc dodanie jest jedno
        setTimeout(() => {
          if (this.variantPending) return; // kolejna zmiana wariantu: kolejka czeka na jej koniec
          this.submitQueued = false;
          this.submitButton.classList.remove("disabled");
          this.submitForm();
        }, 0);
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
